import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth.guard';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { Menu2Component } from './menu2/menu2.component';
import { RecuperaMailComponent } from './recupera-mail/recupera-mail.component';
import { PopupComponent } from './paginas/popup/popup.component';

const routes: Routes = [
 // { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'recupwd/:u', component: RecuperaMailComponent },
  { path: 'userPop', component: PopupComponent },
  { path: 'menu2', component: Menu2Component, canActivate: [AuthGuard] },
  { path: '**', redirectTo:''}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
